import { render } from "./ExpedicionesPrevisionComisiones.vue?vue&type=template&id=4d02df7f&scoped=true"
import script from "./ExpedicionesPrevisionComisiones.vue?vue&type=script&lang=ts"
export * from "./ExpedicionesPrevisionComisiones.vue?vue&type=script&lang=ts"

import "./ExpedicionesPrevisionComisiones.vue?vue&type=style&index=0&id=4d02df7f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4d02df7f"

export default script